import React from 'react';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{
      maxWidth: 720,
      margin: '0 auto',
      padding: '60px 24px',
      fontFamily: 'Inter, -apple-system, sans-serif',
      color: '#f0f0f0',
      lineHeight: 1.7,
    }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: '#888', marginBottom: 40 }}>Last updated: September 2026</p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Overview</h2>
      <p style={{ marginBottom: 24 }}>
        Lineup Foundry is a baseball batting order tool for coaches. This privacy policy explains what data we collect, how we use it, and your rights.
      </p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Data We Collect</h2>
      <p style={{ marginBottom: 12 }}>
        Lineup Foundry collects minimal anonymous usage data to understand how the app is being used and to improve it. Specifically, we collect:
      </p>
      <ul style={{ marginBottom: 24, paddingLeft: 20 }}>
        <li><strong>App opened</strong> — when the app is launched</li>
        <li><strong>CSV imported</strong> — when a roster is imported (file size and player count only, no player names or stats)</li>
        <li><strong>Batting order generated</strong> — which strategy was used and how many players</li>
        <li><strong>PDF exported</strong> — when a lineup card is exported</li>
      </ul>
      <p style={{ marginBottom: 24 }}>
        This data is collected via PostHog, a privacy-focused analytics platform hosted in the EU. No personally identifiable information is collected. No player names, team names, or statistical data ever leaves your device.
      </p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Data We Do NOT Collect</h2>
      <ul style={{ marginBottom: 24, paddingLeft: 20 }}>
        <li>Player names, statistics, or any roster data</li>
        <li>Team names or logos</li>
        <li>Location data</li>
        <li>Device identifiers</li>
        <li>Email addresses or contact information</li>
        <li>Any information that could identify you or your players</li>
      </ul>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Data Storage</h2>
      <p style={{ marginBottom: 24 }}>
        All roster data, batting orders, and team information are stored locally on your device only. This data is never transmitted to any server.
      </p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Third Party Services</h2>
      <p style={{ marginBottom: 24 }}>
        The app uses PostHog (posthog.com) for anonymous analytics. PostHog's privacy policy is available at{' '}
        <a href="https://posthog.com/privacy" style={{ color: '#EF9F27' }}>posthog.com/privacy</a>.
      </p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Children's Privacy</h2>
      <p style={{ marginBottom: 24 }}>
        Lineup Foundry does not knowingly collect any information from children under 13. The anonymous usage analytics described above do not include any personally identifiable information.
      </p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Changes to This Policy</h2>
      <p style={{ marginBottom: 24 }}>
        We may update this policy from time to time. Continued use of the app after changes constitutes acceptance of the updated policy.
      </p>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Contact</h2>
      <p>
        If you have questions about this privacy policy, contact us at:{' '}
        <a href="mailto:jack@lineupfoundry.com" style={{ color: '#EF9F27' }}>jack@lineupfoundry.com</a>
      </p>
    </div>
  );
};
